import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=5b08c835&scoped=true"
import script from "./sidebarMenu.vue?vue&type=script&lang=ts"
export * from "./sidebarMenu.vue?vue&type=script&lang=ts"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&id=5b08c835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08c835",
  null
  
)

export default component.exports